module.exports = __webpack_public_path__ + "34bc775d/img/pwrd-by-sourcery-black.bba9ba41.svg";